import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=2598a102&scoped=true&"
import script from "./OrderStatus.vue?vue&type=script&lang=js&"
export * from "./OrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=2598a102&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598a102",
  null
  
)

export default component.exports